/**
 * Regras de disponibilidade do produto no cardapio digital, compartilhadas
 * pelos cards da listagem e pelas sugestoes do carrinho.
 *
 * Mantem em UM lugar o criterio que decide se o produto pode ir direto ao
 * carrinho ou precisa passar pelo detalhe — o mesmo que `podeConfirmar` aplica
 * em `cardapio-produto-detalhe.component.ts`. Duplicar isso nos componentes
 * arrisca as duas copias divergirem do detalhe.
 */

import { CardapioProdutoDTO } from '../../../models/cardapio-digital/cardapio-digital.model';

/** Teto de unidades para produto sem controle de estoque. */
const LIMITE_SEM_CONTROLE_ESTOQUE = 99;

/**
 * Produto que exige escolha antes de ir ao carrinho: tem variantes de preco ou
 * grupo de modificador obrigatorio. Grupo apenas OPCIONAL nao conta — nesse
 * caso a adicao rapida leva o produto base.
 */
export function exigeConfiguracao(produto: CardapioProdutoDTO | null | undefined): boolean {
  if (!produto) return false;
  if (produto.temVariantes && (produto.variantes?.length ?? 0) > 0) return true;
  return !!produto.modificadores?.some(grupo => grupo.obrigatorio);
}

/**
 * Unidades que ainda cabem no estoque, descontando o que ja esta no carrinho.
 * `saldoDisponivel` nulo significa sem controle de estoque.
 */
export function saldoRestante(
  produto: CardapioProdutoDTO | null | undefined,
  quantidadeNoCarrinho = 0,
): number {
  const saldo = produto?.saldoDisponivel;
  if (saldo == null) return LIMITE_SEM_CONTROLE_ESTOQUE;
  return Math.max(0, Math.floor(saldo) - quantidadeNoCarrinho);
}

/** Sem saldo para adicionar mais unidades (so quando ha controle de estoque). */
export function semEstoqueDisponivel(
  produto: CardapioProdutoDTO | null | undefined,
  quantidadeNoCarrinho = 0,
): boolean {
  return produto?.saldoDisponivel != null && saldoRestante(produto, quantidadeNoCarrinho) <= 0;
}
